export default __webpack_public_path__ + "static/media/logo_topright.fa22e205.png";